import React from "react";
import PropTypes from "prop-types";

import CampaignsPage from "./CampaignsPage";

// Simple wrapper so that react dev tools properly shows the component - The parent component is excluded when loading with ReactOnRails
const CampaignsPageWrapper = (props) => {
  return <CampaignsPage {...props}></CampaignsPage>;
};

CampaignsPageWrapper.propTypes = {
  campaign: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
  givingFormEntity: PropTypes.object.isRequired,
  member: PropTypes.object,
  campaignId: PropTypes.string,
  entityId: PropTypes.string,
  entityUrls: PropTypes.object,
  donorScrollItems: PropTypes.array,
};

export default CampaignsPageWrapper;
